import PropTypes from 'prop-types';
import {useState} from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import CustomTextField from '../common/CustomTextField';
import {useCreateLeadCommentMutation} from '../../redux/services/leadApi';

const handleSubmit = ({lead, createComment, setComment, setSubmitting}) => async (e, comment) => {
  setSubmitting(true);
  const request = await createComment({lead_id: lead.id, content: comment});
  setSubmitting(false);
  if (request.error) {
    alert('Failed to submit comment');
  } else {
    setComment('');
  }
};

const CommentEditor = props => {
  const {lead} = props;
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [createComment] = useCreateLeadCommentMutation();
  const onSubmit = handleSubmit({
    lead,
    createComment, 
    setComment, 
    setSubmitting
  });
  return (
    <Box>
      <Stack alignItems='center'>
        <CustomTextField
          fullWidth
          label='Add Comment'
          type='textarea'
          multiline={true}
          rows={3}
          onChange={e => setComment(e.target.value)}
        />
        <Box>
          <Button
            disabled={submitting}
            onClick={e => onSubmit(e, comment)}
          >
            Save Comment
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

CommentEditor.propTypes = {
  lead: PropTypes.object.isRequired,
};

export default CommentEditor;